import {Home} from './routes' 

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
